export default "__VITE_ASSET__5YKNOqjj__"